// extracted by mini-css-extract-plugin
export default {"toolbar":"ProductList_toolbar__y4sGi","search":"ProductList_search__2449a","create":"ProductList_create__5DkFX"};